function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { useTranslation } from 'react-i18next';
import { Button } from './Button';
var _ref = process.env.NODE_ENV === "production" ? {
  name: "1riulzp",
  styles: "border-color:#82D2FF;border-radius:1rem;height:1.75rem;padding-left:2rem;padding-right:2rem"
} : {
  name: "188d5al-ButtonLoadMore",
  styles: "border-color:#82D2FF;border-radius:1rem;height:1.75rem;padding-left:2rem;padding-right:2rem;label:ButtonLoadMore;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
export function ButtonLoadMore(props) {
  const {
    t
  } = useTranslation();
  return <Button css={_ref} {...props}>
			{t('buttons.loadMore')}
		</Button>;
}